module.exports = __webpack_public_path__ + "static/media/logo-televisa-direccion.df2933e0.svg";